import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CreditCard, Save, Loader2, Repeat } from "lucide-react";
import api from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

// Super Admin: accende/spegne un pagamento con carta (Stripe) e ne imposta il prezzo.
const PaymentSettingCard = ({ endpoint, icon: Icon, title, desc, priceLabel, testid, onMsg, offMsg }) => {
  const [form, setForm] = useState({ enabled: false, price: "" });
  const [busy, setBusy] = useState(false);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    api.get(endpoint).then((r) => { setForm({ enabled: r.data.enabled, price: r.data.price ? String(r.data.price) : "" }); setLoaded(true); }).catch(() => {});
  }, [endpoint]);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(endpoint, { enabled: form.enabled, price: Number(String(form.price).replace(",", ".")) || 0 });
      setForm({ enabled: data.enabled, price: data.price ? String(data.price) : "" });
      toast.success(data.enabled ? onMsg : offMsg);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <div className="rounded-xl border border-border bg-card p-5 space-y-4" data-testid={`${testid}-card`}>
      <div>
        <h3 className="font-heading font-bold flex items-center gap-2"><Icon className="w-4 h-4 text-primary" /> {title}</h3>
        <p className="text-xs text-muted-foreground mt-0.5">{desc}</p>
      </div>
      <div className="grid sm:grid-cols-[auto_1fr_auto] gap-4 items-end">
        <label className="flex items-center gap-3 h-10 cursor-pointer">
          <Switch disabled={!loaded} checked={form.enabled} onCheckedChange={(v) => setForm({ ...form, enabled: v })} data-testid={`${testid}-switch`} />
          <span className="text-sm font-medium" data-testid={`${testid}-state`}>{form.enabled ? "A pagamento" : "Spento"}</span>
        </label>
        <div className="space-y-1.5 max-w-[220px]">
          <Label>{priceLabel}</Label>
          <Input inputMode="decimal" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} placeholder="es. 29" data-testid={`${testid}-price-input`} />
        </div>
        <Button onClick={save} disabled={busy || !loaded} data-testid={`${testid}-save-button`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4 mr-1.5" /> Salva</>}
        </Button>
      </div>
    </div>
  );
};

export const UpgradePaymentCard = () => (
  <PaymentSettingCard endpoint="/superadmin/upgrade-payment" icon={CreditCard} testid="upgrade-payment"
    title="Pagamento per passare all'app completa" priceLabel="Prezzo una tantum (€, IVA inclusa)"
    desc="Finché è spento, le ditte col Gestionale semplice passano all'app completa gratis con un click. Accendilo quando avrai la P.IVA e l'account Stripe attivo."
    onMsg="Pagamento attivo: le ditte pagano con carta per l'app completa" offMsg="Pagamento spento: il passaggio è gratuito" />
);

export const SubscriptionPaymentCard = () => (
  <PaymentSettingCard endpoint="/superadmin/subscription-payment" icon={Repeat} testid="subscription-payment"
    title="Abbonamento mensile dopo la prova" priceLabel="Prezzo al mese (€, IVA inclusa)"
    desc="Finché è spento, il pulsante «Continua» negli avvisi di fine prova porta ai tuoi contatti di assistenza e attivi tu la ditta da qui. Acceso: la ditta si abbona da sola con la carta."
    onMsg="Abbonamento attivo: le ditte possono abbonarsi con la carta" offMsg="Abbonamento spento: «Continua» porta all'assistenza" />
);

export default UpgradePaymentCard;
